export const STORAGE_PREDICATE = "http://www.w3.org/ns/pim/space#storage";
export const TEXT_PREDICATE = "http://schema.org/text";
export const CREATED_PREDICATE = "http://www.w3.org/2002/12/cal/ical#created";
export const QUOTE_CLASS = "http://www.w3.org/2002/12/cal/ical#Vquote";
export const TYPE_PREDICATE = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
